import React, { useState, useEffect } from 'react';
import { Marker } from 'react-leaflet';
import { observationService } from '@iso/services';
import { IconObservation } from '@iso/containers/Pages/PropertyMap/Icons/IconObservation';
import _ from 'lodash';

const Observation = (props) => {
  const [observations, setObservations] = useState([]);
  const objectRef = React.useRef([]);

  const filterActiveObservations = React.useCallback((items = []) => {
    const now = Date.now();
    return _.filter(items, (item) => {
      const isApproved = item?.latest_approval?.status === 'approved';
      if (!isApproved) {
        return false;
      }
      if (!item?.expires_at) {
        return true;
      }
      const expiresAt = Date.parse(item.expires_at);
      if (Number.isNaN(expiresAt)) {
        return true;
      }
      return expiresAt > now;
    });
  }, []);

  const updateDataObservations = React.useCallback((propertyId) => {
    observationService.getList(propertyId, { only_active: 1 }).then(res => {
      if (res.code === '0000') {
        setObservations(filterActiveObservations(res.observations));
      }
    });
  }, [filterActiveObservations]);

  useEffect(() => {
    if (props.propertyId) {
      updateDataObservations(props.propertyId);
    }
  }, [updateDataObservations, props.propertyId]);

  const handleShowObservations = (data) => {
    var html = [];
    if (data.length > 0) {
      _.forEach(data, function(observation){
        html.push(
          <Marker 
            key={observation.id} 
            position={[observation.lat, observation.lng]}
            icon={IconObservation()}
            ref={el => (objectRef.current[observation.id] = el)}
          />
        );
      });
    }
    return html;
  }

  return (
    <>
      {handleShowObservations(observations)}
    </>
  )
}

export default Observation;
